import axios from 'axios';
import envService from "@/services/env.service";
import userService from "@/services/user.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/block/prefix';

export default {
    getBlockList(page, size, sort) {
        const params = {
            'page': page,
            'size': size,
            'sort': sort
        }
        return axios.get(BASE_URL, {params: params});
    },

    getBlockedPrefix(prefixId) {
        return axios.get(BASE_URL + "/" + prefixId);
    },
   addBlockedPrefix(prefix, editor, comment) {
        return axios.post(BASE_URL,
            {
                "prefix": prefix,
                "editor": editor,
                "comment": comment,
            })
    },

    updateBlockedPrefix(id, prefix, comment, editor) {
        return axios.put(BASE_URL + '/' + id,
            {
                "prefix": prefix,
                "comment": comment,
                "editor": editor,
            })
    },

    deleteBlockedPrefix(prefixId) {
        return axios.delete(BASE_URL + '/' + prefixId, {
            headers: {
                'X-User-Email': userService.getLoggedInUser().email,
            }
        });
    }
}